require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/assign.js
// module id = 257
// module chunks = 9 35 38 42 49 53 78 79 82 88 92 164 165 171 172